import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withPageContainer from '../../shared/page-container/with-page-container';
import Animate from '../../shared/animation';

import Table from '../components/table/general/main';
import Filters from '../../shared/filters/main';
import Groups from '../components/groups/main';
import Save from '../components/save-export/main';
import Calendar from '../../shared/calendar/main';
import SwitchStats from '../components/switch/main';
import CurrencySwitch from '../../shared/currency-switch';
import MasterSwitch from '../components/master-switch/main';

lessRequire('modules/statistics/general/main.less');

import switchStatsLinkConfig from '../shared/switch-cfg.js';

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = withPageContainer(props =>
	<Animate>
		<div className="container">
			<div className="container__content statistics">
				<div className="container__content-title">
					<h2 className="font-proxima-nova-bold">
						{props.intl('Статистика')}
					</h2>
					<SwitchStats links={switchStatsLinkConfig} intl={props.intl} />

					{!isRocket && (
						<div className="statistics-position__currency">
							<CurrencySwitch
								listOfCurrencies={props.listOfCurrencies}
								activeCurrency={props.activeCurrency}
								onSwitch={props.changeCurrency} />
						</div>
					)}
					{
						props.isMaster &&
						<MasterSwitch options={props.masterSwitchConfig} onSwitch={props.applyMasterSwitch} intl={props.intl} />
					}
				</div>

				<div className="container__content-body">
					<div className="stats-wrap__control">
						<Filters {...props} filterApply={props.statisticsFilterApply} />
						<div className="stats-wrap__control-bottom clearfix">
							<button className="reset-btn" onClick={e => props.statsReset()} />
							<button className="submit-btn" onClick={e => props.statsApply()} />
							<Save
								{...props.savedFilters}
								onToggle={props.savedFiltersToggle}
								onApply={props.savedFiltersApply}
								onSave={props.savedFiltersSave}
								onExport={props.statExport}
								intl={props.intl}
							/>
							<div className="stats-wrap__control-calendar">
								<Calendar
									{...props.calendar}
									onInit={props.calendarInit}
									onToggle={props.calendarToggle}
									onChange={props.calendarChange}
									onApply={props.calendarApply}
									intl={props.intl}
								/>
							</div>
							<Groups {...props} />
						</div>
					</div>
					<Table {...props} />
				</div>
			</div>
		</div>
	</Animate>
);

export default connect(
	state => ({
		data: selectors.getData(state),
		dataTable: selectors.getDataTable(state),
		filters: selectors.getFilters(state),
		appliedFilters: selectors.getAppliedFilters(state),
		groups: selectors.getGroups(state),
		calendar: selectors.getCalendar(state),
		isShowedAutoTrash: selectors.getIsShowedAutoTrash(state),
		columnControlConfig: selectors.getColumnControlConfig(state),
		savedFilters: selectors.getSavedFilters(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		listOfCurrencies: selectors.getListOfCurrencies(state),
		activeCurrency: selectors.getActiveCurrency(state),
		masterSwitchConfig: selectors.getMasterSwitchConfig(state),
		isMaster: selectors.getIsMasterStatus(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/general/main.js